import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import { initTranslator as initTranslatorCore } from '~domain/i18n';
import { TranslationMap } from '~domain/model/core/supported-languages';

export function initTranslator(translations: Partial<TranslationMap<object>>) {
  return initTranslatorCore(translations, {
    plugins: [LanguageDetector, initReactI18next],
    // React already escape stuff correctly, so not needed
    escapeValue: false,
  });
}
